module.exports = __webpack_public_path__ + "static/media/refresh-button.36053a5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/refresh-button.svg
// module id = 189
// module chunks = 0